import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
export const FeedbackButton = ({ fullWidth = false, withMargin = true, variant }) => {
    return (_jsx("div", { css: css `
        margin-top: ${withMargin ? '10px' : 'initial'};
      `, children: _jsx(Button, { onClick: () => window.open('https://forms.gle/jcMB9yH8DyNzXDit6', '_blank'), size: 'small', fullWidth: fullWidth, variant: variant, children: "Feedback / Bug Report" }) }));
};
